// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 982 ? "default-drawer-header" : chunkId) + "." + {"533":"0ff755dd","788":"4f034e44","982":"c57a5160"}[chunkId] + ".css";
};